import { useState } from "react";
import briansteinLogo from '../../assets/logos/brianstein.png';


function StickyBrianstein() {
    const [showBriansteinJoke, setShowBriansteinJoke] = useState(false);

    return (
        <div className="brianstein-sticky">
            <img
                src={briansteinLogo}
                alt="Brianstein"
                className="brianstein-image"
                onClick={() => {
                    setShowBriansteinJoke(true);
                    setTimeout(() => setShowBriansteinJoke(false), 5000);
                }}
            />
            {showBriansteinJoke && (
                <div className="brianstein-joke-bubble">
                    <div className="joke-content">
                        <p>Hello! I am Brianstein! 🤖</p>
                    </div>
                    <div className="joke-arrow"></div>
                </div>
            )}
        </div>
    )
}


export default StickyBrianstein;